import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalsoftDatePipe } from './calsoft-date.pipe';



@NgModule({
  declarations: [CalsoftDatePipe],
  imports: [
    CommonModule
  ],
  exports:[CalsoftDatePipe]
})
export class CalsoftpipeModule { }
